/* eslint-disable indent */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Add from '@mui/icons-material/Add';

import {
  Divider,
  Icon,
  ListItemButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Paper,
  Chip,
  Collapse,
  IconButton,
} from '@mui/material';
import {
  Delete,
  MoreVert,
  Settings,
  Schedule,
  AccountBox,
  LocationOn,
  AccessAlarm,
  Error,
  NoteAlt,
  AttachMoney,
  InfoOutlined,
  Task,
  Group,
  MoneyOff,
  AutoAwesome,
  ArrowCircleLeft,
  ExpandLess,
  ExpandMore,
  PersonOff,
  Alarm,
} from '@mui/icons-material';
import moment from 'moment';
import { blueGrey } from '@mui/material/colors';
import BarnHorsesAutocomplete from '../../../../Autocompletes/BarnHorses';
import BarnUsersAutocomplete from '../../../../Autocompletes/BarnUsers';
import LocationsAutocomplete from '../../../../Autocompletes/Locations';
import UserMentionTextField from '../../../../UserMentionTextField';

import Horse from '../../../../Horse';
import HorseIcon from '../../../../CustomIcons/Horse';

import { getBarnUsersForAssignmentString } from '../../../../../utils/scheduleHelper';
import {
  primary,
  grey,
  danger,
  secondary,
} from '../../../../../utils/brandColors';
import HorseBillablePrice from '../../../../EventData/HorseBillablePrice';
import HorseNote from '../../../../EventData/HorseNote';
import TaskStatus from '../../../../TaskStatus'
import useDebounce from '../../../../../utils/useDebounce';
import { getStatusItemSecondaryText } from '../../../../StatusAssignment';
import DueDate from '../../../../EventData/DueDate';
import ScheduleParticipant from '../ScheduleParticipant';
import LocationChip from '../../../../LocationChip';
import { getAvatarGroupForUsers } from '../../../../Planner/components/TaskCalendarOverview/components/TaskOverviewCell';

const TasksSection = ({
  schedule,
  event,
  eventTemplate,
  workflows,
  setWorkflows,
  validation,
  type,
  setType,
  disabledForBeingInPast,
  name,
  setName,
  setAssignment,
  restOfSuggestions,
}) => {
  const [selectedTaskAnchorEl, setSelectedTaskAnchorEl] = React.useState(false);
  const [initialWorkflowIndexSet, setInitialWorkflowIndexSet] = React.useState(false);
  const [selectedTaskIndex, setSelectedTaskIndex] = React.useState(-1);
  const [statusComment, setStatusComment] = React.useState('');
  const [otherHorseSuggestions, setOtherHorseSuggestions] = React.useState([]);

  const debouncedComment = useDebounce(statusComment, 500);
  const eventData = useSelector((state) => state.eventData.eventData);

  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const locationsMap = useSelector((state) => state.location.locationsMap);
  const boardBarnHorses = useSelector((state) => state.board.barnHorses);
  const statuses = useSelector((state) => state.status.statuses);
  const permissions = useSelector((state) => state.user.permissions);

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name;

  React.useEffect(() => {
    if (eventTemplate) {
      const otherHorsesWithSuggestions = [];

      const taskIdAsString = `${eventTemplate.id}`
      if (restOfSuggestions) {
        for (let i = 0; i < restOfSuggestions.length; i += 1) {
          if (restOfSuggestions[i].allSuggestions
            && restOfSuggestions[i].allSuggestions.find((t) => t === taskIdAsString)) {
            otherHorsesWithSuggestions.push(restOfSuggestions[i].barnHorse)
          }
        }
      }
      setOtherHorseSuggestions(otherHorsesWithSuggestions
        .filter((bh) => boardBarnHorses.find((bbh) => bh.pingumTagId === bbh.pingumTagId)
          && !workflows.find((w) => w.tagIds.find((t) => t === bh.pingumTagId))))
    }
  }, [restOfSuggestions, eventTemplate]);

  React.useEffect(() => {
    setSelectedTaskIndex(-1)
    setStatusComment('');
    setInitialWorkflowIndexSet(false);
  }, [schedule, event])

  React.useEffect(() => {
    if (selectedTaskIndex >= 0) {
      const updatedWorkflows = workflows;
      updatedWorkflows[selectedTaskIndex].startingStatusComment = debouncedComment;
      setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
    }
  }, [debouncedComment])

  React.useEffect(() => {
    if (!initialWorkflowIndexSet) {
      const selectedWorkflow = workflows && workflows[selectedTaskIndex];
      if (!workflows || workflows.length === 0 || (selectedWorkflow && !workflows.find((w) => (`${w.tagIds}`) === (`${selectedWorkflow.tagIds}`)))) {
        // Remove selected workflow
        setSelectedTaskIndex(-1);
      } else if (event && event.workflowTagId && workflows && workflows.length > 0 && selectedTaskIndex < 0) {
        // find selected if passed in
        setSelectedTaskIndex(workflows.findIndex((w) => event && event.workflowTagId && `${w.tagIds}` === `${[event.workflowTagId]}`) || 0);
      } else {
        // Default to the last index
        setSelectedTaskIndex(workflows.length - 1);
      }
      setInitialWorkflowIndexSet(true);
    }
  }, [workflows])

  // const horseTagTypeId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTagTypeId) || 0;
  const horseTaskTypeTagId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTaskTypeTagId) || 0;
  const barnTaskTypeTagId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.barnTaskTypeTagId) || 0;

  const eventTemplateTags = (eventTemplate && eventTemplate.tags) || [];
  const horseTaskTypeTag = eventTemplateTags.filter((t) => t.id === horseTaskTypeTagId).length > 0
    ? eventTemplateTags.filter((t) => t.id === horseTaskTypeTagId)[0]
    : null;
  const barnTaskTypeTag = eventTemplateTags.filter((t) => t.id === barnTaskTypeTagId).length > 0
    ? eventTemplateTags.filter((t) => t.id === barnTaskTypeTagId)[0]
    : null;

  if (!eventTemplate || !eventTemplate.id) return <div />;

  const w = workflows[selectedTaskIndex];
  const workflowStatus = statuses
    .find((s) => s.id === ((selectedTaskIndex >= 0 && workflows[selectedTaskIndex] && workflows[selectedTaskIndex].startingStatusId)))
  const workflowStatusComment = selectedTaskIndex >= 0 && workflows[selectedTaskIndex] && workflows[selectedTaskIndex].startingStatusComment

  return (
    <Grid
      container
      sx={{ mb: 2 }}
      spacing={2}
    >
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Task color="secondary" sx={{ mr: 1 }} />
            <Typography
              variant="h5"
              sx={{
                color: validation.workflows
                  ? danger[500]
                  : 'default',
              }}
            >{horseTaskTypeTag
              ? `Horses (${workflows.length})`
              : `Locations (${workflows.length})`}
            </Typography>

          </Box>
          <Tooltip
            title={`Add Another ${horseTaskTypeTag
              ? 'Horse'
              : 'Location'} Task`}
          >
            <IconButton
              disabled={workflows.length > 0 && !!workflows.find((ww) => !ww.tagIds || ww.tagIds.length === 0)}
              onClick={() => {
                if (!workflows.find((ww) => ww.tagIds.length === 0)) {
                  // Only add if there are no other empty tasks
                  setSelectedTaskIndex(workflows.length)
                  setWorkflows([...workflows, {
                    eventTemplateId: eventTemplate.id,
                    tagIds: [],
                    createEvents: true,
                    startingAssignment: '',
                    dueDateStatusChangeId: eventTemplate.dueDateStatusChangeId,
                    dueDateTime: eventTemplate.dueDateDefaultTime || 0,
                    dueDateTimeEndOfDay: eventTemplate.dueDateDefaultTimeEndOfDay || false,
                    eventDataDefaultValues: eventTemplate.eventDataDefaultValues || {},
                  }])
                }
              }}
            ><Add />
            </IconButton>
          </Tooltip>
        </Box>
      </Grid>
      {
        workflows.map((workflow, index) => {
          const ws = statuses
            .find((s) => s.id === ((index >= 0 && workflow.startingStatusId)))
          const wsc = index >= 0 && workflow.startingStatusComment
          const barnHorse = horseTaskTypeTag
            && ((workflow.tagIds && workflow.tagIds.length === 1 && barnHorsesMap[workflow.tagIds[0]]
              && barnHorsesMap[workflow.tagIds[0]][0]) || null)
          const location = !barnHorse && barnTaskTypeTag
            && ((workflow.tagIds && workflow.tagIds.length === 1 && locationsMap[workflow.tagIds[0]]
              && locationsMap[workflow.tagIds[0]][0]) || null);
          const color = (eventTemplate.eventDataDefaultValues
            && eventTemplate.eventDataDefaultValues.calendarDisplayColor)
            || primary.main

          const dueDateTime = workflow.dueDateTime || 0
          const dueDateTimeEndOfDay = workflow.dueDateTimeEndOfDay || false;
          const billableValue = (workflow.eventDataDefaultValues
            || {})[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)];
          const billableReceivable = (workflow.eventDataDefaultValues || {})['Billable Receivable'] || 'yes';
          // const billableStatus = (workflow.eventDataDefaultValues || {})['Billable Status'] || 'Open';
          const horseNote = workflow.eventDataDefaultValues[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)]
          return (
            <Grid item xs={12} key={`workflow-container-${(workflow.tagIds && workflow.tagIds.join('')) || '0'}-${index}`}>
              <Paper
                elevation={2}
                sx={{
                  padding: 1,
                  borderLeft: `8px solid ${color}`,
                  borderTopLeftRadius: 8,
                  borderBottomLeftRadius: 8,

                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    '&:hover': {
                      opacity: '75%',
                      cursor: 'pointer',
                    },
                  }}
                  onClick={() => {
                    setSelectedTaskIndex(selectedTaskIndex === index
                      ? -1
                      : index);
                  }}
                >
                  <Box
                    sx={{
                      pr: 1,
                      mr: 1,
                      borderRight: `1px solid ${blueGrey[50]}`,
                    }}
                  >
                    {
                      !barnHorse && !location && (
                        <Error
                          color={
                            validation.workflows
                              ? 'error'
                              : 'warning'
                          }
                        />
                      )
                    }
                    {barnHorse
                      && (
                        <Horse
                          horse={barnHorse.horse}
                        />
                      )}
                    {location && (
                      <Box>
                        <LocationChip
                          location={location}
                        />
                      </Box>
                    )}
                  </Box>
                  <Grid container spacing={1} alignItems="center" sx={{ flex: 1 }} justifyContent="flex-end" flexWrap="wrap">

                    {
                      !!dueDateTime
                      && (
                        <Grid item>
                          <Tooltip
                            title={
                              dueDateTimeEndOfDay
                                ? 'Complete this task by end of day'
                                : `Complete this task by ${moment(new Date(new Date().getTime() + dueDateTime)).fromNow().replace('in ', '')} from start`
                            }
                          >
                            <Alarm color="secondary" />
                          </Tooltip>
                        </Grid>
                      )
                    }
                    {
                      horseNote && (
                        <Grid item>
                          <Tooltip title="Creates a note on horse profile">
                            <NoteAlt color="secondary" />
                          </Tooltip>
                        </Grid>
                      )
                    }
                    {
                      billableValue && (
                        <Grid item>
                          <Tooltip title={`Creates a billing transaction on horse: $${billableValue}`}>
                            {
                              billableReceivable === 'yes'
                                ? <AttachMoney color="success" />
                                : <MoneyOff color="secondary" />
                            }
                          </Tooltip>
                        </Grid>
                      )
                    }

                    {
                      ((ws && ws.id !== selectedBarn.barnMetadata.statusStartId) || wsc) && (
                        <Grid item>
                          <Chip
                            size="small"
                            color="primary"
                            icon={
                              (ws || wsc)
                                ? (
                                  <Icon
                                    sx={{ fontSize: '18px' }}
                                    color="primary"
                                  >{(ws && ws.icon) || eventTemplate.defaultStartStatus.icon}
                                  </Icon>
                                )
                                : (<Schedule sx={{ fontSize: '18px' }} color="primary" />)
                            }
                            label={(ws && ws.name) || (event && 'Scheduled') || 'Pending'}
                          />
                        </Grid>
                      )
                    }
                    {
                      workflow.scheduleAssignment && (
                        <Grid item>
                          <Tooltip title="Task Participants">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                border: `1px solid ${secondary[500]}`,
                                borderRadius: 20,
                                gap: 0.5,
                              }}
                            >
                              <Group color="secondary" sx={{ paddingLeft: '2px' }} />
                              {getAvatarGroupForUsers(getBarnUsersForAssignmentString(workflow.scheduleAssignment || '', barnUsersMap), '')}
                            </Box>
                          </Tooltip>
                        </Grid>
                      )
                    }
                    <Grid item>
                      <Tooltip
                        title={workflow.startingAssignment
                          ? 'Task Assignment'
                          : 'Unassigned Task'}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {getAvatarGroupForUsers(getBarnUsersForAssignmentString(workflow.startingAssignment || '', barnUsersMap), '')}
                          {
                            !workflow.startingAssignment && <PersonOff color="secondary" />
                          }
                        </Box>
                      </Tooltip>
                    </Grid>
                    <Grid item>
                      {selectedTaskIndex === index
                        ? <ExpandLess />
                        : <ExpandMore />}
                    </Grid>
                  </Grid>
                </Box>
                {
                  selectedTaskIndex === index && (
                    <Collapse in={selectedTaskIndex === index}>
                      <Box sx={{ height: '100%' }}>
                        <ListItemText
                          sx={{
                            backgroundColor: grey[50],
                            borderRadius: 4,
                            mt: 2,
                            mb: 1,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <TaskStatus
                              eventStatus={{
                                assignment: (workflows[selectedTaskIndex] && workflows[selectedTaskIndex].startingAssignment) || '',
                                statusComment: workflowStatusComment,
                                status: workflowStatus || {
                                  ...statuses.find((s) => s.id === selectedBarn.barnMetadata.statusStartId),
                                  name: 'Scheduled Task',
                                  statusIcon: 'schedule',
                                },
                              }}
                              icon={(workflowStatus && workflowStatus.icon) || 'schedule'}
                              color={primary[500]}
                              archived={false}
                              complete={!!(workflowStatus && workflowStatus.completeEvent)}
                              scheduled
                            />
                            <Button
                              size="small"
                              sx={{ mr: 2 }}
                              endIcon={<MoreVert />}
                              onClick={(e) => {
                                setSelectedTaskAnchorEl(e.currentTarget);
                                setStatusComment(workflows[selectedTaskIndex].startingStatusComment || '')
                              }}
                              disabled={disabledForBeingInPast}
                            >
                              Actions
                            </Button>
                          </Box>
                        </ListItemText>
                        <ListItem dense sx={{ px: 0 }}>
                          <ListItemIcon>
                            {horseTaskTypeTag
                              ? <HorseIcon />
                              : <LocationOn />}
                          </ListItemIcon>
                          <ListItemText>
                            {horseTaskTypeTag
                              ? (
                                <BarnHorsesAutocomplete
                                  multiple={false}
                                  validation={((w.tagIds === null || workflow.tagIds.length === 0) && validation.workflows)
                                    ? validation.workflows
                                    : ''}
                                  value={(w.tagIds && workflow.tagIds.length === 1
                                    && barnHorsesMap[w.tagIds[0]] && barnHorsesMap[w.tagIds[0]][0]) || null}
                                  onSelect={(e, newHorse) => {
                                    // take selected barn horses and map to tags
                                    const updatedWorkflows = workflows;
                                    updatedWorkflows[selectedTaskIndex].tagIds = newHorse
                                      ? [parseInt(newHorse.pingumTagId, 10)]
                                      : [];
                                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                  }}
                                  limitTags={1}
                                  barnHorses={boardBarnHorses && boardBarnHorses.length > 0
                                    ? boardBarnHorses
                                    : undefined}
                                  disabled={disabledForBeingInPast}
                                />
                              )
                              : (
                                <LocationsAutocomplete
                                  multiple={false}
                                  validation={((w.tagIds === null || workflow.tagIds.length === 0) && validation.workflows)
                                    ? validation.workflows
                                    : ''}
                                  value={(w.tagIds && workflow.tagIds.length === 1
                                    && locationsMap[w.tagIds[0]] && locationsMap[w.tagIds[0]][0]) || null}
                                  onSelect={(e, newLocations) => {
                                    // take selected locations and map to tags
                                    const updatedWorkflows = workflows;
                                    updatedWorkflows[selectedTaskIndex].tagIds = newLocations
                                      ? [parseInt(newLocations.pingumTagId, 10)]
                                      : [];
                                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                  }}
                                  size="small"
                                  limitTags={1}
                                  disabled={disabledForBeingInPast}
                                />
                              )}
                          </ListItemText>
                        </ListItem>
                        <ListItem dense divider sx={{ px: 0 }}>
                          <ListItemIcon><AccountBox /></ListItemIcon>
                          <ListItemText>
                            <BarnUsersAutocomplete
                              label="Assigned User"
                              multiple
                              blurOnSelect
                              value={getBarnUsersForAssignmentString(w.startingAssignment || '', barnUsersMap)}
                              onSelect={(e, newBarnUsers) => {
                                // take selected barn users and map to assignment syntax @[NAME](AUTH0_USER_ID)
                                const updatedWorkflows = workflows;
                                updatedWorkflows[selectedTaskIndex].startingAssignment = newBarnUsers.map((bu) => (bu.id
                                  ? `@[${bu.userFullName}](${bu.auth0UserId || bu.email})`
                                  : `@[${bu.userFullName || bu}](${null})`)).join('');
                                setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                              }}
                              limitTags={1}
                              disabled={disabledForBeingInPast}
                              suggestAssignmentHorseTagId={barnHorse && barnHorse.pingumTagId}
                              clientAccessHorseId={barnHorse && barnHorse.horse.id}
                            />
                          </ListItemText>
                          <Tooltip title="Assigned users are responsible for doing any work associated with and completing the task in Questri. These users will see the task on their task list in the mobile app and barn board.">
                            <InfoOutlined
                              sx={{
                                ml: 1,
                                fontSize: 20,
                              }}
                              color="secondary"
                            />
                          </Tooltip>
                        </ListItem>
                        <ScheduleParticipant
                          schedule={schedule}
                          event={event}
                          blurOnSelect
                          validation={validation}
                          assignment={w.scheduleAssignment}
                          setAssignment={(newAssignment) => {
                            const updatedWorkflows = workflows;
                            updatedWorkflows[selectedTaskIndex].scheduleAssignment = newAssignment;

                            // make sure each workflow assignment is added to schedule assignment
                            setAssignment(updatedWorkflows.map((ww) => ww.scheduleAssignment || '').join(''));

                            // Now assign to the workflow
                            setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                          }}
                          type={type}
                          setType={setType}
                          name={name}
                          setName={setName}
                          disabledForBeingInPast={disabledForBeingInPast}
                          suggestParticipantHorseTagId={barnHorse && barnHorse.pingumTagId}
                          clientAccessHorseId={barnHorse && barnHorse.horse.id}
                        />
                        <ListItem
                          dense
                          divider
                          sx={{ px: 0 }}
                        >
                          <ListItemIcon sx={{ mt: 0.5 }}><AccessAlarm /></ListItemIcon>
                          <ListItemText>
                            <DueDate
                              workflows={workflows}
                              setWorkflows={setWorkflows}
                              selectedTaskIndex={selectedTaskIndex}
                              entityIdentifier={`${workflows[selectedTaskIndex].taskIds}`}
                            />
                          </ListItemText>
                        </ListItem>

                        {
                          horseTaskTypeTag && (
                            <ListItem dense divider sx={{ px: 0 }}>
                              <ListItemIcon><AttachMoney /></ListItemIcon>
                              <ListItemText>
                                <HorseBillablePrice
                                  onChange={(newEventDataDefaults) => {
                                    const updatedWorkflows = workflows;
                                    updatedWorkflows[selectedTaskIndex].eventDataDefaultValues = newEventDataDefaults;
                                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                  }}
                                  eventDataDefaultValues={workflows[selectedTaskIndex].eventDataDefaultValues}
                                  showHeader={false}
                                  type="inline"
                                  entityIdentifier={`${workflows[selectedTaskIndex].taskIds}`}
                                />
                              </ListItemText>
                            </ListItem>
                          )
                        }

                        {
                          horseTaskTypeTag && (
                            <ListItem dense sx={{ px: 0 }}>
                              <ListItemIcon><NoteAlt /></ListItemIcon>
                              <ListItemText>
                                <HorseNote
                                  onChange={(newEventDataDefaults) => {
                                    const updatedWorkflows = workflows;
                                    updatedWorkflows[selectedTaskIndex].eventDataDefaultValues = newEventDataDefaults;
                                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                  }}
                                  eventDataDefaultValues={workflows[selectedTaskIndex].eventDataDefaultValues}
                                  showHeader={false}
                                  type="inline"
                                  entityIdentifier={`${workflows[selectedTaskIndex].taskIds}`}
                                />
                              </ListItemText>
                            </ListItem>
                          )
                        }
                        <Box
                          sx={{
                            textAlign: 'right',
                            mt: 1,
                          }}
                        >
                          <Button
                            color="secondary"
                            size="small"
                            onClick={() => {
                              const updatedWorkflows = workflows;
                              updatedWorkflows.splice(selectedTaskIndex, 1);
                              setWorkflows(updatedWorkflows);
                              setSelectedTaskIndex(workflows.length - 1);
                              setSelectedTaskAnchorEl(null)
                            }}
                          >
                            Remove {horseTaskTypeTag
                              ? 'Horse'
                              : 'Location'}
                          </Button>
                        </Box>
                      </Box>
                    </Collapse>
                  )
                }
              </Paper>
            </Grid>

          )
        })
      }

      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: 1,
          }}
        >
          <Box sx={{ width: 170 }}>
            {horseTaskTypeTag
              ? (
                <BarnHorsesAutocomplete
                  multiple
                  label="Select Horse(s)"
                  validation={validation.workflows && 'At least one task is required'}
                  value={[]}
                  onSelect={(e, newHorses) => {
                    // check for duplicates
                    if (newHorses && newHorses.length === 1) {
                      if (workflows.find((ww) => `${ww.tagIds}` === `${[parseInt(newHorses[0].pingumTagId, 10)]}`)) {
                        return; // Don't allow duplicate
                      }

                      const newWorkflows = JSON.parse(JSON.stringify([...workflows, {
                        eventTemplateId: eventTemplate.id,
                        tagIds: [parseInt(newHorses[0].pingumTagId, 10)],
                        createEvents: true,
                        startingAssignment: '',
                        dueDateStatusChangeId: eventTemplate.dueDateStatusChangeId,
                        dueDateTime: eventTemplate.dueDateDefaultTime || 0,
                        dueDateTimeEndOfDay: eventTemplate.dueDateDefaultTimeEndOfDay || false,
                        eventDataDefaultValues: eventTemplate.eventDataDefaultValues || {},
                      }])) // force react to refresh
                      setWorkflows(newWorkflows);
                    }
                  }}
                  limitTags={1}
                  barnHorses={boardBarnHorses && boardBarnHorses.length > 0
                    ? boardBarnHorses.filter((bh) => !workflows || !workflows.find((ww) => `${ww.tagIds[0]}` === bh.pingumTagId))
                    : undefined}
                />
              )
              : (
                <LocationsAutocomplete
                  multiple={false}
                  label="Select Location"
                  validation={validation.workflows && 'At least one task is required'}
                  value={null}
                  onSelect={(e, newLocations) => {
                    // check for duplicates
                    if (workflows.find((ww) => `${ww.tagIds}` === `${[parseInt(newLocations.pingumTagId, 10)]}`)) {
                      return; // Don't allow duplicate
                    }

                    setWorkflows(JSON.parse(JSON.stringify([...workflows, {
                      eventTemplateId: eventTemplate.id,
                      tagIds: [parseInt(newLocations.pingumTagId, 10)],
                      createEvents: true,
                      startingAssignment: '',
                      dueDateStatusChangeId: eventTemplate.dueDateStatusChangeId,
                      dueDateTime: eventTemplate.dueDateDefaultTime || 0,
                      dueDateTimeEndOfDay: eventTemplate.dueDateDefaultTimeEndOfDay || false,
                      eventDataDefaultValues: eventTemplate.eventDataDefaultValues || {},
                    }]))); // force react to eventTemplate
                  }}
                  size="small"
                  limitTags={1}
                />
              )}

          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mt: 0.5,
            }}
          >
            <ArrowCircleLeft
              color="secondary"
              sx={{
                height: 20,
                width: 20,
                mr: '2px',
                ml: 1,
              }}
            />
            <Typography
              textAlign="center"
              sx={{
                fontWeight: 300,
                maxWidth: 170,
                fontSize: 12,
              }}
            >Add Another Task
            </Typography>
          </Box>
        </Box>
      </Grid>

      {
        otherHorseSuggestions.length > 0 && (
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mt: 2,
              }}
            >
              <AutoAwesome sx={{ color: '#FF6600 !important' }} />
              <Typography
                sx={{ ml: 1 }}
              >
                Other Horses Suggesting This Task
              </Typography>
            </Box>
            <Grid container spacing={1}>
              {otherHorseSuggestions.map((bh) => (
                <Grid
                  item
                  key={`suggestion-horse-${bh.id}`}
                >
                  <Horse
                    chip
                    horse={bh.horse}
                    clickable
                    onClick={() => {
                      // check for duplicates
                      if (workflows.find((ww) => `${ww.tagIds}` === `${[parseInt(bh.pingumTagId, 10)]}`)) {
                        return; // Don't allow duplicate
                      }

                      setWorkflows(JSON.parse(JSON.stringify([...workflows, {
                        eventTemplateId: eventTemplate.id,
                        tagIds: [parseInt(bh.pingumTagId, 10)],
                        createEvents: true,
                        startingAssignment: '',
                        dueDateStatusChangeId: eventTemplate.dueDateStatusChangeId,
                        dueDateTime: eventTemplate.dueDateDefaultTime || 0,
                        dueDateTimeEndOfDay: eventTemplate.dueDateDefaultTimeEndOfDay || false,
                        eventDataDefaultValues: eventTemplate.eventDataDefaultValues || {},
                      }]))); // force react to refresh
                      setOtherHorseSuggestions(otherHorseSuggestions.filter((h) => h.id !== bh.id))
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        )
      }
      <Menu
        id="menu-appbar"
        anchorEl={selectedTaskAnchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={!!selectedTaskAnchorEl}
        onClose={() => {
          if (statuses
            .find((s) => s.id === ((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
              || eventTemplate.defaultStartStatus.id)).requireComment && !statusComment) {
            return;
          }
          setSelectedTaskAnchorEl(null);
        }}
      >
        <MenuItem>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <TextField
                select
                label="Task Status"
                name="status"
                id="status-select"
                variant="outlined"
                size="small"
                fullWidth
                value={(selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                  || (eventTemplate && eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id)}
                onChange={(e) => {
                  if (e.target.value === -1) {
                    window.location.href = '/settings/tasks/statuses'
                  } else {
                    const updatedWorkflows = workflows;
                    updatedWorkflows[selectedTaskIndex].startingStatusId = e.target.value;
                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                  }
                }}
                SelectProps={{
                  renderValue: () => {
                    const status = statuses
                      .find((s) => s.id === ((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || eventTemplate.defaultStartStatus.id));
                    return (
                      <ListItem sx={{ p: 0 }} dense>
                        <Icon
                          sx={{
                            color: primary[500],
                            mr: 2,
                          }}
                        >{status.icon}
                        </Icon>
                        <ListItemText
                          primary={status.name}
                          secondaryTypographyProps={{ component: 'div' }}
                          secondary={getStatusItemSecondaryText(status, {})}
                        />
                      </ListItem>
                    )
                  },
                }}
              >
                {
                  statuses.sort((a, b) => a.statusOrder - b.statusOrder).map((status) => (
                    <ListItemButton
                      dense
                      key={`status-${status.id}`}
                      value={status.id}
                      button={((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id)) !== status.id}
                      disabled={((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id)) === status.id}
                    >
                      <Icon
                        sx={{
                          mr: 1,
                          color: primary[500],
                        }}
                      >{status.icon}
                      </Icon>
                      <ListItemText
                        primary={status.name}
                        secondaryTypographyProps={{ component: 'div' }}
                        secondary={getStatusItemSecondaryText(status, {})}
                      />
                    </ListItemButton>
                  ))
                }

                {(permissions.admin || permissions.owner) && (
                  <Divider />
                )}
                {(permissions.admin || permissions.owner) && (
                  <ListItemButton
                    dense
                    value={-1}
                  >
                    <Settings color="secondary" sx={{ mr: 1 }} />
                    <ListItemText
                      primary="Manage available task statuses"
                      secondary="Selecting this will take you away from this page, and any changes won't be saved."
                    />
                  </ListItemButton>
                )}
              </TextField>
              <Tooltip title="Done editing status">
                <Button
                  size="small"
                  variant="outlined"
                  disabled={statuses
                    .find((s) => s.id === (((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                      || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id))) || {}).requireComment && !statusComment}
                  onClick={() => { setSelectedTaskAnchorEl(null); }}
                >
                  Done
                </Button>
              </Tooltip>
            </Box>
            <UserMentionTextField
              value={statusComment}
              label="Task Status Comment"
              rows={2}
              onChange={(e) => setStatusComment(e.target.value)}
              required={statuses
                .find((s) => s.id === (((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                  || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id))) || {}).requireComment}
              error={statuses
                .find((s) => s.id === (((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                  || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id))) || {}).requireComment && !statusComment}
              helperText="Leave a comment or message on this task."
            />
          </Box>

        </MenuItem>
        <Divider sx={{ my: 1 }} />
        <MenuItem
          onClick={() => {
            const updatedWorkflows = workflows;
            updatedWorkflows.splice(selectedTaskIndex, 1);
            setWorkflows(updatedWorkflows);
            setSelectedTaskIndex(workflows.length - 1);
            setSelectedTaskAnchorEl(null)
            // make sure each workflow assignment is added to schedule assignment
            setAssignment(updatedWorkflows.map((ww) => ww.scheduleAssignment || '').join(''));
          }}
        >
          <ListItemIcon>
            <Delete color="error" />
          </ListItemIcon>
          Remove {horseTaskTypeTag
            ? 'Horse'
            : 'Location'}
        </MenuItem>
      </Menu>
    </Grid>
  );
};

TasksSection.propTypes = {
  eventTemplate: PropTypes.object,
  schedule: PropTypes.object,
  event: PropTypes.object,
  workflows: PropTypes.array,
  validation: PropTypes.object.isRequired,
  setWorkflows: PropTypes.func,
  disabledForBeingInPast: PropTypes.bool,
  type: PropTypes.string.isRequired,
  setType: PropTypes.func,
  name: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
  setAssignment: PropTypes.func,
  restOfSuggestions: PropTypes.array,

};

TasksSection.defaultProps = {
  eventTemplate: {},
  schedule: {},
  event: {},
  workflows: [],
  setWorkflows: () => { },
  disabledForBeingInPast: false,
  setType: () => { },
  setAssignment: () => { },
  restOfSuggestions: [],
};

export default TasksSection;
